module.exports = __webpack_public_path__ + "static/media/gas_icon.ce9103e0.svg";